import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {

    return (
        <footer>
            <div className="container text-white">
                <div className="row">
                    {/* Partie 1 */}
                    <div className="col-md-4 mb-3 mb-md-0">
                        <Link className="navbar-brand" to="/">
                            <h3>La clef</h3>
                        </Link>
                        <ul className="list-unstyled">
                            <li><Link className="text-white" to="/Validation">Validation</Link></li>
                            <li><Link className="text-white" to="/Univers">Univers</Link></li>
                            <li><Link className="text-white" to="/Bonus">Bonus</Link></li>
                        </ul>
                    </div>


                    {/* Partie 2 */}
                    <div className="col-md-4 mb-3 mb-md-0">
                        <h3><Link className="text-white" to="/AideDeJeu">Aide de jeu</Link></h3>
                        <ul className="list-unstyled">
                            <li>
                                <Link
                                    className="text-white"
                                    to="/AideDeJeu#conseils"
                                    onClick={() => handleAnchorScroll('#conseils')}
                                >
                                    Conseils pour se lancer
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className="text-white"
                                    to="/AideDeJeu#indices"
                                    onClick={() => handleAnchorScroll('#indices')}
                                >
                                    Indices
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className="text-white"
                                    to="/AideDeJeu#encre-invisible"
                                    onClick={() => handleAnchorScroll('#encre-invisible')}
                                >
                                    Encre invisible
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Partie 3 */}
                    <div className="col-md-4">
                        <div className="footerBoutique">
                            <Link className="btn link-capsule" aria-current="page" target="_blank" to="https://www.fanelia.art/22-la-clef">Découvrir la boutique</Link>
                            <div className="row rowIcons">
                                <div className="col">
                                    <a href="https://www.facebook.com/LaClefAstolie/" className="text-white mr-2" aria-label="Facebook">
                                        <i className="bi bi-facebook btnIcon" style={{ fontSize: '20px' }}></i>
                                    </a>
                                    <a href="https://x.com/LaClefAstolie" className="text-white mr-2" aria-label="Twitter">
                                        <i className="bi bi-twitter btnIcon" style={{ fontSize: '20px' }}></i>
                                    </a>
                                    <a href="https://www.instagram.com/fanelia_art/" className="text-white mr-2" aria-label="Instagram">
                                        <i className="bi bi-instagram btnIcon" style={{ fontSize: '20px' }}></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




            </div>
            <div className='text-center footerSecondaire'>
                <p className='m-0'>La Clef - Fanélia 2026 - <Link className="text-dark" to="/Mentionslegales">Mentions légales du site</Link> </p>
            </div>
        </footer >
    );
};

const handleAnchorScroll = (hash) => {
    const targetElement = document.querySelector(hash);
    if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
    }
};


export default Footer;
